'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import './PrePublishState.scss';

const PrePublishState = ({ projectCode }) => (
	<div className="PrePublishedContainer">
		<div className="InnerHeader">
			<div className="Headline">
				<h2>{projectCode}</h2>
			</div>
		</div>
		<div className="InnerContent">
			<div className="Questions">
				<h3>
					<a target="_blank" href="mailto:clientsuccess@metabolon.com" rel="noreferrer">Questions? Contact us</a>
				</h3>
			</div>
		</div>
	</div>
);


PrePublishState.propTypes = {
	projectCode: PropTypes.string
};


export default PrePublishState;